export default function isNumber(value: unknown): value is number {
  if (Number.isNaN(value)) {
    return false;
  }

  return typeof value === "number";
}
